import React from 'react'
import About from '../about/About'
import Pages from '../page/Pages'
import Store from '../store/Store'
import './maincontent.css'

const MainContent = () => {

      return (
            <div className="section_main flex">
                  <About />
                  <Pages />
                  <Store />
            </div>
      )
}

export default MainContent
